import { $$ } from 'utils/dom';
import { ImageLazerLoader } from 'modules/lazer-loader';
import { isImageLoaded } from 'utils/helper';

// Lazy load all images with attribute
const targets = $$('picture[data-lazerload]:not(.prevent-lazy)');

export const ImageLazer = new ImageLazerLoader({
  targets,
  config: {
    rootMargin: '0px',
    threshold: 0.01,
  },
  cb: entry => {
    const target = entry.target;
    target.setAttribute('data-lazerload', 'loaded');
    isImageLoaded(target.getElementsByTagName('img')[0]).then(response => {
      // console.log('loaded', response.image.currentSrc);
    });
  },
});
ImageLazer.init();
